import React from "react";
import { BaseButton } from "./BaseButton";
import { useLocation } from "react-router-dom";
import useNavigate from "src/hooks/usePartnerNavigate";

const SearchResetButton = () => {
  const { pathname, search } = useLocation();
  const navigate = useNavigate();
  return (
    <div className="flex-center">
      <div className="search-divider mr10" />
      <BaseButton
        className="color-white"
        title="검색해제"
        onClick={() => {
          // if (!search) return;
          navigate(pathname);
        }}
      />
    </div>
  );
};

export default SearchResetButton;
